const NON_CONDO_PATHS = new Set([
  '/', '/login', '/register', '/account', '/admin', '/council', '/approvals',
  '/forgot-password', '/terms', '/privacy',
]);

const NON_CONDO_PREFIXES = ['/reset-password/', '/unsubscribe/', '/admin/', '/council/'];

// Condo pages (Tickets/Bulletins/Calendar/Forum/etc.) are shaped as
// /:condoSlug[/section]; every other top-level route is a fixed string
// enumerated above. Used by useBottomNavTarget to read the active condo
// slug straight out of the URL when we're inside a condo section.
export function isCondoScopedPath(pathname) {
  if (NON_CONDO_PATHS.has(pathname)) return false;
  return !NON_CONDO_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

// The Admin and Council portals use the full screen width.
export function isAdminPath(pathname) {
  return ['/admin', '/council'].some((root) => pathname === root || pathname.startsWith(`${root}/`));
}

// Pages whose click text may go to Laftel Analytics. Every other page shows residents' data, so the app
// shell marks it data-l-private (clicks are still counted, without their text).
const PUBLIC_PATHS = new Set(['/', '/login', '/register', '/terms', '/privacy']);

export function isPublicPath(pathname) {
  return PUBLIC_PATHS.has(pathname);
}
